import React, { lazy } from 'react'
import { CustomWebhooksLoader } from 'router/Loaders/CustomWebhooksLoader'
import { LoaderSwitcher } from 'router/Loaders'

const ManageCustomWebhook = lazy(
  () => import('components/Integrations/Manage/ManageCustomWebhook')
)

// Also loaded on create: creating a webhook patches the list in place
// (useCustomWebhook.ts) rather than refetching, so it must be loaded first.
export const ManageCustomWebhookWrapper = () => (
  <CustomWebhooksLoader>
    {(isLoaded) => (
      <LoaderSwitcher isParentLoaded={isLoaded}>
        <ManageCustomWebhook />
      </LoaderSwitcher>
    )}
  </CustomWebhooksLoader>
)
